// extracted by mini-css-extract-plugin
export default {"welcomePanelOverride":"ald_alaska-theme__welcomePanelOverride__r2GVg"};